import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from "@angular/animations";

export function fadeInOut(timingIn: string): AnimationTriggerMetadata  {
  return trigger('fadeInOut', [
    state('fadeIn', style({ 
      display: 'block',
      background: 'rgba(0, 0, 0, 0.7)'
     })),
    state('fadeOut', style({ 
      display: 'none',
      background: 'rgba(0, 0, 0, 0)'
    })),
    transition('fadeIn <=> fadeOut', [
      animate(timingIn),
    ]),
    transition('* => fadeIn', [
      animate(timingIn),
    ]),
    transition('* => fadeOut', [
      animate(timingIn),
    ]),
    transition('* => *', [
      animate(timingIn),
    ]),
  ]);
}